import React, { useState } from "react";
import { createInvoice, reconcileBilling } from "../../api/billing";

export default function BillingInvoicePage() {
  const [planId, setPlanId] = useState("plan_s");
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [invoiceRes, setInvoiceRes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const onCreate = async () => {
    try {
      setLoading(true);
      setErr("");
      const data = await createInvoice({ planId, billingCycle });
      setInvoiceRes(data);
    } catch (e) {
      setErr(e?.response?.data?.error || e.message || "Failed");
    } finally {
      setLoading(false);
    }
  };

  const onReconcile = async () => {
    try {
      setLoading(true);
      setErr("");
      const data = await reconcileBilling({});
      alert("Reconcile done: " + JSON.stringify(data));
    } catch (e) {
      setErr(e?.response?.data?.error || e.message || "Failed");
    } finally {
      setLoading(false);
    }
  };

  const invoice = invoiceRes?.invoice;
  const instruction = invoiceRes?.instruction;

  return (
    <div className="billing-invoice-page" style={{ padding: 24 }}>
      <h2>Billing / Invoice</h2>

      <div className="billing-toolbar" style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 16 }}>
        <label>
          Plan:
          <select value={planId} onChange={(e) => setPlanId(e.target.value)} style={{ marginLeft: 8 }}>
            <option value="plan_s">plan_s</option>
            <option value="plan_l">plan_l</option>
          </select>
        </label>

        <label>
          Cycle:
          <select value={billingCycle} onChange={(e) => setBillingCycle(e.target.value)} style={{ marginLeft: 8 }}>
            <option value="monthly">monthly</option>
            <option value="annual">annual</option>
          </select>
        </label>

        <button onClick={onCreate} disabled={loading}>
          Create Invoice
        </button>

        <button onClick={onReconcile} disabled={loading}>
          Reconcile
        </button>
      </div>

      {err && <div style={{ color: "red", marginBottom: 12 }}>{err}</div>}

      {invoice && (
        <div className="billing-result-card" style={{ border: "1px solid #ddd", padding: 16, borderRadius: 8 }}>
          <div><b>Invoice ID:</b> {invoice.id}</div>
          <div><b>Status:</b> {invoice.status}</div>
          <div><b>Amount:</b> ¥{invoice.amount}</div>
          <div><b>Memo:</b> {invoice.memoExpected || "-"}</div>
          <div><b>Payment Ref:</b> {invoice.paymentRef || "-"}</div>

          <div style={{ marginTop: 12 }}>
            <b>Instruction:</b> {instruction}
          </div>

          <div className="billing-actions" style={{ marginTop: 12, display: "flex", gap: 10 }}>
            <button
              onClick={() => navigator.clipboard.writeText(String(invoice.amount))}
            >
              Copy Amount
            </button>
            <button
              onClick={() => navigator.clipboard.writeText(String(invoice.memoExpected || ""))}
              disabled={!invoice.memoExpected}
            >
              Copy Memo
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
